import { BaseballEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../configuration'

export const pitchBlockedEventStatus: PitchBlockedEventStatus<BaseballEventStatusId> =
  new Set([
    BaseballEventStatusId.Abandoned,
    BaseballEventStatusId.Cancelled,
    BaseballEventStatusId.NotStarted,
    BaseballEventStatusId.StartDelayed,
    BaseballEventStatusId.Postponed,
    BaseballEventStatusId.Interrupted,
    BaseballEventStatusId.ToFinish,
    BaseballEventStatusId.FinishedAwardedWin,
    BaseballEventStatusId.Finished,
    BaseballEventStatusId.FinishedAfterExtraInning,
    BaseballEventStatusId.DelayedByRain,
    BaseballEventStatusId.CalledGame,
    BaseballEventStatusId.CancelledDueRain,

    BaseballEventStatusId.BreakAfterFirstInning,
    BaseballEventStatusId.BreakAfterSecondInning,
    BaseballEventStatusId.BreakAfterThirdInning,
    BaseballEventStatusId.BreakAfterFourthInning,
    BaseballEventStatusId.BreakAfterFifthInning,
    BaseballEventStatusId.BreakAfterSixthInning,
    BaseballEventStatusId.BreakAfterSeventhInning,
    BaseballEventStatusId.BreakAfterEighthInning,
    BaseballEventStatusId.BreakAfterNinthInning,
    BaseballEventStatusId.BreakAfterTenthInning,
    BaseballEventStatusId.BreakAfterEleventhInning,
    BaseballEventStatusId.BreakAfterTwelfthInning,
    BaseballEventStatusId.BreakAfterThirteenthInning,
    BaseballEventStatusId.BreakAfterFourteenthInning,
    BaseballEventStatusId.BreakAfterFifteenthInning,
    BaseballEventStatusId.BreakAfterSixteenthInning,
    BaseballEventStatusId.BreakAfterSeventeenthInning,
    BaseballEventStatusId.BreakAfterEighteenthInning,
    BaseballEventStatusId.BreakAfterNineteenthInning,
    BaseballEventStatusId.BreakAfterTwentiethInning,
    BaseballEventStatusId.BreakAfterTwentyFirstInning,
    BaseballEventStatusId.BreakAfterTwentySecondInning,
  ])
